module.exports = __webpack_public_path__ + "static/semantic-card-basic-178032e99fc656170948f93bbd8e801a.png";